import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persistedstate';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { setUnauthorizedHandler } from './api/http';
import { useAuthStore } from './store/auth';
import './assets/main.scss';

const pinia = createPinia();
pinia.use(piniaPersist);

const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(vuetify);

setUnauthorizedHandler(() => {
  const auth = useAuthStore();
  const wasAuthenticated = auth.isAuthenticated;
  auth.logout();
  if (wasAuthenticated) {
    const redirect = `${router.currentRoute.value.fullPath}`;
    router.push({ name: 'home', query: { expired: '1', redirect } });
  }
});

app.mount('#app');

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
